import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  cartListData: {}, // this holds cart data
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartDetails: (state, action) => {
      state.loading = false;
      state.cartListData = action.payload;
    },
    clearCart: (state) => {
      state.cartListData = {};
    },
  },
});

export const { setCartDetails, clearCart } = cartSlice.actions;

export default cartSlice.reducer;
